import { builder } from '@builder.io/react';

// used for builder init
const BUILDER_API = process.env.NEXT_PUBLIC_BUILDER_API;

if (BUILDER_API) {
	builder.init(BUILDER_API);
	// Set API version to v3 for consistency
	builder.apiVersion = 'v3';
}

// Side-effect imports only: each register runs Builder.registerComponent.
// We do not re-export (many registers export defaultOptions, which would conflict).
import './Form/register';
import './Button/register';
import './Header/register';
import './Hero/register';
import './HeroWithImage/register';
import './SecondaryHero/register';
import './Layout/register';
import './ThreeColumn/register';
import './Settlements/register';
import './CopyAndImage/register';
import './Accordion/register';
import './CtaSection/register';
import './IconList/register';
import './SingleForm/register';
import './customMenus';
import './MainHeader/register';
import './ListAndImage/register';
import './QuoteAndStats/register';
import './BulletedImageList/register';
import './TrapezoidHero/register';
import './SplashHero/register';
import './Listicle/register';
import './ContactUs/register';
import './BragBar/register';
import './BragBarV2/register';
import './MiniSplash/register';
import './StickyCTA/register';
import './StatusPill/register';
import './CalloutBox/register';
import './HeaderV2/register';
import './LayoutSQV2/register';
import './TestimonialCarousel/register';
import './HeroOverlappedImage/register';
import './SettlementCalculator/register';
import './TextBragBar/register';
import './AccordionV2/register';
